import { Download, RefreshCw } from "lucide-react";

function SupportHeader({ reload }) {

    return (

        <div className="support-header">

            <div>

                <h1>Support Center</h1>

                <p>
                    Manage customer support tickets.
                </p>

            </div>

            <div className="support-actions">

                <button
                    className="refresh-btn"
                    onClick={reload}
                >

                    <RefreshCw size={18} />

                    Refresh

                </button>

                <button className="export-btn">

                    <Download size={18} />

                    Export

                </button>

            </div>

        </div>

    );

}

export default SupportHeader;